<template>
  <modal :show.sync="modals.classic" type="mini">
    <h4 slot="header" class="title title-up">
      {{ $t("app.modules.order_entry_schedule.add.title") }}
    </h4>
    <ValidationObserver ref="formAdd" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitNewType)">
        <div class="row text-left">
          <div :class="'form-group has-label ' + sizes">
            <label>{{
              $t("app.modules.order_entry_schedule.headers.order_category")
            }}</label>
            <el-select
              class="select-primary"
              size="large"
              :placeholder="
                $t('app.modules.order_entry_schedule.headers.order_category')
              "
              v-model="item.catProd_idCategoriaProducto"
            >
              <el-option
                v-for="categoria in categorias"
                class="select-primary"
                :value="categoria.idCategoriaProducto"
                :label="categoria.nombreCategoria"
                :key="categoria.idCategoriaProducto"
              >
              </el-option>
            </el-select>
            <div
              v-if="selectedEmptyOption"
              class="text-danger invalid-feedback"
              style="display: block;"
            >
              {{ required_text }}
            </div>
          </div>
          <div :class="'form-group has-label ' + sizes">
            <label>{{
              $t("app.modules.order_entry_schedule.headers.end_time")
            }}</label>
            <template style="margin-top: 4px">
              <el-time-picker
                arrow-control
                v-model="horafin"
                :placeholder="
                  $t('app.modules.order_entry_schedule.headers.end_time')
                "
              >
              </el-time-picker>
              <div
                v-if="selectedEmpty"
                class="text-danger invalid-feedback"
                style="display: block;"
              >
                {{ required_text }}
              </div>
            </template>
          </div>
        </div>
        <div
          slot="footer"
          style="margin-top: 10px; padding-top: 20px;border-top: outset;"
          class="text-right"
        >
          <n-button class="pull-left btn-secondary" @click.native="cancelAdd()">{{
            $t("app.buttons.cancel")
          }}</n-button>
          <n-button native-type="submit" type="primary">{{
            $t("app.buttons.save")
          }}</n-button>
        </div>
      </form>
    </ValidationObserver>
  </modal>
</template>
<script>
import { mapState } from "vuex";
export default {
  components: {},
  data() {
    return {
      selectedEmptyOption: false,
      categorias: [],
      selectedEmpty: false,
      required_text: this.$t("app.general.required"),
      sizes: "col-md-12 col-sm-12",
      horafin: new Date(2020, 9, 10, 18, 40),
      item: {
        idHorarioIngresoPedido: 0,
        nombreCategoria: "",
        horafin: {},
        catProd_idCategoriaProducto: 0
      },
      modals: {
        classic: false
      }
    };
  },
  watch: {
    horafin(value) {
      if (value) {
        this.selectedEmpty = false;
        this.item.horaString =
          this.addDigit(this.horafin.getHours()) +
          ":" +
          this.addDigit(this.horafin.getMinutes()) +
          ":" +
          this.addDigit(this.horafin.getSeconds());
      } else {
        this.selectedEmpty = true;
      }
    }
  },
  computed: {},
  created() {},
  mounted() {
    EventBus.$on("order-schedule-add", async () => {
      this.tableData = [];
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      this.initHorarioAdd();
      this.$swal.close();
      this.modals.classic = true;
    });
  },
  methods: {
    async initHorarioAdd() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      var payload = {
        id: 0,
        claveIdioma: this.$store.state.lang,
        usuario: this.$store.state.user.idUsuario,
        withCategories: false
      };
      await this.$http
        .post(route("CategoriaProducto/getCategoria"), payload)
        .then(
          async response => {
            if (response.body.code === 200) {
              this.categorias = response.body.categoriaProducto;
              this.categorias.push({
                idCategoriaProducto: 0,
                nombreCategoria: this.$t(
                  "app.modules.order_entry_schedule.headers.order_category"
                )
              });
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            console.log(error);
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {
          // Swal.close();
        });
      this.$swal.close();
    },
    addDigit(textDigit) {
      var digits_return = "";
      if (textDigit.toString().length < 2) {
        digits_return = "0" + textDigit.toString();
      } else {
        digits_return = textDigit.toString();
      }
      return digits_return;
    },
    async submitNewType() {
      console.log(this.item);
      if (this.horafin) {
        this.selectedEmpty = false;
        if (this.item.catProd_idCategoriaProducto) {
          this.selectedEmptyOption = false;
          this.saveItem();
        } else {
          this.selectedEmptyOption = true;
        }
      } else {
        this.selectedEmpty = true;
      }
    },
    async saveItem() {
      this.item.horaString =
        this.addDigit(this.horafin.getHours()) +
        ":" +
        this.addDigit(this.horafin.getMinutes()) +
        ":" +
        this.addDigit(this.horafin.getSeconds());
      //Guardar item
      console.log("Guardar item");
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      await this.$http
        .post(route("HorarioIngresoPedido/addHorarioIngresoPedido"), this.item)
        .then(
          async response => {
            if (response.body.code === 200) {
              this.notifyMessage("success", this.$t("app.promps.save_success"));
              EventBus.$emit("reload-items-horario");
              this.cancelAdd();
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            this.trubbleSave = true;
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
      this.$swal.close();
    },
    cancelAdd() {
      this.$refs.formAdd.reset();
      this.item.nombreCategoria = "";
      this.modals.classic = false;
    },
    async submitNewUsuario() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      await this.addNewRole();
      this.$swal.close();
    },
    async addNewRole() {}
  }
};
</script>
<style>
.extended-forms .el-select {
  width: 100%;
  margin-bottom: 30px;
}
.card .alert {
  position: relative !important;
  width: 100%;
}

.modal-content .modal-header {
  padding-bottom: 24px;
  box-shadow: 0px 2px 5px 0px #00000021;
}

.modal-content .modal-body + .modal-footer {
  padding-top: 20px !important;
  background-color: #efefefb3;
}
</style>
